import "./GchGalleryStyles.css";

import foodDorian1 from "../Assets/Gallery/FoodAidDorian/Dorian-1.jpg";
import foodDorian2 from "../Assets/Gallery/FoodAidDorian/Dorian-2.jpg";
import foodDorian3 from "../Assets/Gallery/FoodAidDorian/Dorian-3.jpg";
import foodDorian4 from "../Assets/Gallery/FoodAidDorian/Dorian-4.jpg";
import foodDorian5 from "../Assets/Gallery/FoodAidDorian/Dorian-5.jpg";
import foodDorian6 from "../Assets/Gallery/FoodAidDorian/Dorian-6.jpg";
import foodDorian7 from "../Assets/Gallery/FoodAidDorian/Dorian-7.jpg";
import foodDorian8 from "../Assets/Gallery/FoodAidDorian/Dorian-8.jpg";
import foodDorian9 from "../Assets/Gallery/FoodAidDorian/Dorian-9.jpg";
import foodDorian10 from "../Assets/Gallery/FoodAidDorian/Dorian-10.jpg";
import foodDorian11 from "../Assets/Gallery/FoodAidDorian/Dorian-11.jpg";
import foodDorian12 from "../Assets/Gallery/FoodAidDorian/Dorian-12.jpg";
import foodDorian13 from "../Assets/Gallery/FoodAidDorian/Dorian-13.jpg";
import foodDorian14 from "../Assets/Gallery/FoodAidDorian/Dorian-14.jpg";
import foodDorian15 from "../Assets/Gallery/FoodAidDorian/Dorian-15.jpg";
import foodDorian16 from "../Assets/Gallery/FoodAidDorian/Dorian-16.jpg";
import foodDorian17 from "../Assets/Gallery/FoodAidDorian/Dorian-17.jpg";
import foodDorian18 from "../Assets/Gallery/FoodAidDorian/Dorian-18.jpg";
import foodDorian19 from "../Assets/Gallery/FoodAidDorian/Dorian-19.jpg";
import foodDorian20 from "../Assets/Gallery/FoodAidDorian/Dorian-20.jpg";
import foodDorian21 from "../Assets/Gallery/FoodAidDorian/Dorian-21.jpg";
import foodDorian22 from "../Assets/Gallery/FoodAidDorian/Dorian-22.jpg";
import foodDorian23 from "../Assets/Gallery/FoodAidDorian/Dorian-23.jpg";
import foodDorian24 from "../Assets/Gallery/FoodAidDorian/Dorian-24.jpg";
import turkeyEq1 from "../Assets/Gallery/TurkeyEarthquake/Turkey-1.jpg";
import turkeyEq2 from "../Assets/Gallery/TurkeyEarthquake/Turkey-2.jpg";
import turkeyEq3 from "../Assets/Gallery/TurkeyEarthquake/Turkey-3.jpg";
import turkeyEq4 from "../Assets/Gallery/TurkeyEarthquake/Turkey-4.jpg";
import turkeyEq5 from "../Assets/Gallery/TurkeyEarthquake/Turkey-5.jpg";
import turkeyEq6 from "../Assets/Gallery/TurkeyEarthquake/Turkey-6.jpg";
import turkeyEq7 from "../Assets/Gallery/TurkeyEarthquake/Turkey-7.jpg";
import turkeyEq8 from "../Assets/Gallery/TurkeyEarthquake/Turkey-8.jpg";
import turkeyEq9 from "../Assets/Gallery/TurkeyEarthquake/Turkey-9.jpg";
import turkeyEq10 from "../Assets/Gallery/TurkeyEarthquake/Turkey-10.jpg";
import turkeyEq11 from "../Assets/Gallery/TurkeyEarthquake/Turkey-11.jpg";
import turkeyEq12 from "../Assets/Gallery/TurkeyEarthquake/Turkey-12.jpg";
import turkeyEq13 from "../Assets/Gallery/TurkeyEarthquake/Turkey-13.jpg";

function FoodAidDorian() {
  return (
    <div className="gallery-container">
      <div className="GCH-event-activity-heading">
        <h4>Food Aid Assistance to Bahama (Dorian-2019)</h4>
      </div>
      <div className="GCH-event-activity-gallery">
        <div>
          <img alt="child-image" src={foodDorian1} />
          <img alt="child-image" src={foodDorian2} />
          <img alt="child-image" src={foodDorian3} />
          <img alt="child-image" src={foodDorian4} />
          <img alt="child-image" src={foodDorian5} />
          <img alt="child-image" src={foodDorian6} />
          <img alt="child-image" src={foodDorian24} />
          <img alt="child-image" src={foodDorian8} />
        </div>
        <div>
          <img alt="child-image" src={foodDorian9} />
          <img alt="child-image" src={foodDorian10} />
          <img alt="child-image" src={foodDorian11} />
          <img alt="child-image" src={foodDorian12} />
          <img alt="child-image" src={foodDorian13} />
          <img alt="child-image" src={foodDorian14} />
          <img alt="child-image" src={foodDorian15} />
          <img alt="child-image" src={foodDorian16} />
        </div>
        <div>
          <img alt="child-image" src={foodDorian7} />
          <img alt="child-image" src={foodDorian17} />
          <img alt="child-image" src={foodDorian18} />
          <img alt="child-image" src={foodDorian19} />
          <img alt="child-image" src={foodDorian20} />
          <img alt="child-image" src={foodDorian21} />
          <img alt="child-image" src={foodDorian22} />
          <img alt="child-image" src={foodDorian23} />
        </div>
      </div>

      <div className="GCH-event-activity-heading">
        <h4>Assistance to Turkey Earthquake (2023)</h4>
      </div>
      <div className="GCH-event-activity-gallery">
        <div>
          <img alt="child-image" src={turkeyEq1} />
          <img alt="child-image" src={turkeyEq4} />
          <img alt="child-image" src={turkeyEq7} />
          <img alt="child-image" src={turkeyEq10} />
        </div>
        <div>
          <img alt="child-image" src={turkeyEq2} />
          <img alt="child-image" src={turkeyEq5} />
          <img alt="child-image" src={turkeyEq11} />
          <img alt="child-image" src={turkeyEq8} />
        </div>
        <div>
          <img alt="child-image" src={turkeyEq3} />
          <img alt="child-image" src={turkeyEq6} />
          <img alt="child-image" src={turkeyEq9} />
          <img alt="child-image" src={turkeyEq12} />
          <img alt="child-image" src={turkeyEq13} />
        </div>
      </div>
    </div>
  );
}

export default FoodAidDorian;
